import api from "./api";

export function fnTutorialVideosList(cModule) {
     const response = api.get(`/video-tutorial/${cModule}`);
     return response;
}

export function fnIncrementVideoView(cVideoId) {
    const response = api.post(`/video-tutorial/${cVideoId}/add-view-counter`);
    return response;
}